<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">権限検索</span>
      </v-card-title>
      <v-card-actions>
        <!-- <v-btn @click="load" class="btn-search">{{$t('app.buttons.search')}}</v-btn> -->
        <v-btn to="/M0021/new" v-if="isAdmin">{{
          $t('app.buttons.new')
        }}</v-btn>

        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          v-permit.SHARP_AUTHORITY_EDIT.SHARP_AUTHORITY_DETAIL
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length !== 1"
          @click="remove"
          v-if="isAdmin"
          >{{ $t('app.buttons.remove') }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="roles"
        :rows-per-page-items="[10]"
        class="elevation-0"
        hide-actions
        item-key="roleId"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.roleCode }}</td>
          <td>{{ props.item.roleName }}</td>
          <td>{{ props.item.functions }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  components: {},
  data: () => ({
    query: {
      page_index: 1,
      page_size: 10000,
    },
    roles: [],
    selected: [],
    headers: [
      { text: '権限グループCD', value: 'roleCode', sortable: false },
      { text: '権限グループ名', value: 'roleCode_local', sortable: false },
      { text: '権限詳細', value: 'functions', sortable: false },
    ],
  }),
  computed: {
    isAdmin() {
      return this.$isAdmin()
    },
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
        },
      }
    },
    loadFunctionsByRoleId(id) {
      return this.$http
        .get(`/auth-service/auth/get-role-functions?roleId=${id}`)
        .then((res) => {
          if (res.data.success) {
            return res.data.data
          } else {
            return []
          }
        })
    },
    loadRoles() {
      return this.$http.get(`/auth-service/auth/get-role-list`).then((res) => {
        if (res.data.success) {
          return res.data.data.data
        } else {
          return []
        }
      })
    },
    load() {
      this.loadRoles().then((roles) => {
        return Promise.all(
          roles.map((r) => {
            return this.loadFunctionsByRoleId(r.roleId).then((functions) => {
              console.log(functions.filter((f) => !f.children))
              r.functions = functions
                .filter((f) => f.checked)
                .filter((f) => !!f.children)
                .map((f) => f.children)
                .flat()
                .filter((f) => f.checked)
                .filter((f) => !!f.name)
                .map((f) => f.name)
                .join(',')
            })
          })
        ).then(() => {
          this.roles = roles
          console.log(roles)
        })
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0021',
        query: { id: this.selected[0].roleId },
      })
    },
    remove() {
      this.$confirm({
        content: `当該権限を削除したいですか。 Role: ${
          this.selected[0].roleName
        }`,
      }).then(() => {
        this.$http
          .delete(
            `/auth-service/auth/delete-role?roleId=${this.selected[0].roleId}`
          )
          .then((res) => {
            if (res.data.success) {
              this.$message('', this.$t('app.messages.removeSuccess'))
              this.refresh()
            } else {
              this.$message(this.$t('app.messages.errors.title'), 'FAILED')
            }
          })
          .catch(() => {
            this.$message(this.$t('app.messages.errors.title'), 'FAILED')
          })
      })
    },
    refresh() {
      this.selected = []
      this.load()
    },
  },
  mounted() {
    this.load()
  },
}
</script>
